import { faArrowRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { mockBookData, mockIndustryProblem, mockSolveProblems } from "../../../mock"
import Footer from "../../footer"
import NavBar from "../../nav"
import './index.scss'

const ComplianceSeminar = () => {
  return <div>
    <NavBar />
    <div className='compliance-seminar__logo' />
    <div className='compliance-seminar__header'>
      <p>SEP 7-8, 2023</p>
      <p>UNDERSTANDING THE WHY IN 135 TIME TO EVOLVE</p>
      <p>FLY COMPLIANT'S 5TH COMPLIANT SOLUTIONS SEMINAR</p>
      <div className='compliance-seminar__header--buttons'>
        <button className='btn primary'>Register</button>
        <button className='btn primary'>Book Room</button>
      </div>
    </div>
    <div className='compliance-seminar__grid'>
      {mockBookData.map((item, idx) => <div key={idx}>
        <div className='compliance-seminar__block-text'>
          <p>{item.title}</p>
          <p>{item.content}</p>
          <p className='compliance-seminar__link'>View More</p>
        </div>
      </div>)}
    </div>
    <div className='compliance-seminar__hotel-info'>
      <div className='compliance-seminar__hotel-info--flight-1' />
      <div className='compliance-seminar__hotel-info--text'>
        <p>Hotel Info</p>
        <p>Hosted by Fly Compliant, LLC</p>
        <p>Hilton Garden Inn</p>
        <p>305 Korean Veterans Blvd.</p>
        <p>Nashville, TN 37201</p>
        <button className='btn primary'>Book Room <FontAwesomeIcon icon={faArrowRight} /></button>
      </div>
      <div className='compliance-seminar__hotel-info--text'>
        <p>Agenda</p>
        <p>For 135 Department Managers</p>
        <p>Day 1: 16:00-20:00 (Meet & Greet Mixer)</p>
        <p>Day 2: 09:00-16:30</p>
        <button className='btn primary'>See the Agenda <FontAwesomeIcon icon={faArrowRight} /></button>
      </div>
      <div className='compliance-seminar__hotel-info--flight-2' />
    </div>
    <div className='compliance-seminar__industry'>
      <span>
        <p className='compliance-seminar__industry--header'>Industry Problems</p>
        {mockIndustryProblem.map((problem, idx) => <p key={idx} className='compliance-seminar__industry--li'>
          <p>{idx + 1}</p>
          <p>{problem}</p>
        </p>)}
      </span>
      <span className='compliance-seminar__industry--solutions'>
        <p className='compliance-seminar__industry--header'>3 Solutions that help solve industry problems</p>
        <p className='compliance-seminar__industry--sub-header'>A 3-Step Process</p>
        {mockSolveProblems.map((solution, idx) => <p key={'s' + idx} className='compliance-seminar__industry--li'>
          <p>{idx + 1}</p>
          <p>{solution}</p>
        </p>)}
      </span>
    </div>
    <div className='compliance-seminar__industry__sellout'>
      <span>
        <p>Tickets sell out quick</p>
        <p>We’re looking forward to seeing you</p>
      </span>
      <button className='btn primary'>Register Now <FontAwesomeIcon icon={faArrowRight} /></button>
    </div>
    <Footer />
  </div >
}

export default ComplianceSeminar